export const SEARCH_USERS = "SEARCH_USERS",
  GET_USER = "GET_USER",
  CLEAR_USERS = "CLEAR_USERS",
  GET_REPOS = "GET_REPOS",
  SET_LOADING = "SET_LOADING",
  SET_ALERT = "SET_ALERT",
  REMOVE_ALERT = "REMOVE_ALERT";
